import { BusinessTransactionDto } from '@app/api/dmc';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { DATE_TIME_FORMAT } from '@app/core/constants/date-time-format';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const meteringPointBusinesstransactionTable: TableConfig<BusinessTransactionDto> = {
  selectable: true,
  selectableType: 'single',
  columns: [
    {
      title: 'Transaktionstype',
      key: 'pipelineType',
      cellRenderer: TranslateCellComponent,
      cellRendererParams:
        {
          notspecified: 'enum.pipelinetype.notspecified',
          request: 'enum.pipelinetype.request',
          response: 'enum.pipelinetype.response',
          notify: 'enum.pipelinetype.notify',
          todo: 'enum.pipelinetype.todo',
          todohandled: 'enum.pipelinetype.todohandled',
        }
    },
    {
      title: 'RSM Nummer',
      key: 'rsmNumber',
    },
    {
      title: 'RSM Navn',
      key: 'rsmName',
    },
    {
      title: 'Årsagskode (BRC)',
      key: 'businessReasonCode',
    },
    {
      title: 'Oprettelsesdato',
      key: 'createdTS',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: DATE_TIME_FORMAT,
      }
    },
    {
      title: 'Udførelsesdato',
      key: 'occurrence',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'Oprettet af',
      key: 'createdBy',
    },
    {
      title: 'Status',
      key: 'status',
    }
  ]
}
